import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// pages
import { PageCategoryComponent } from './pages/page-category/page-category.component';
import { PageProductComponent } from './pages/page-product/page-product.component';
import { PageShopComponent } from './pages/page-shop/page-shop.component';
// resolvers
import { CategoryResolver } from './resolvers/category.resolver';
import { ProductResolver } from './resolvers/product.resolver';
import { ProductsListResolver } from './resolvers/products-list.resolver';
import { RootCategoriesResolver } from './resolvers/root-categories.resolver';
// guards

const routes: Routes = [
    // {
    //     path: '',
    //     pathMatch: 'full',
    //     redirectTo: 'category',
    // },
    {
        path: 'category',
        component: PageCategoryComponent,
        data: {
            layout: 'columns-4-sidebar',
        },
        resolve: {
            children: RootCategoriesResolver,
        },
    },
    {
        path: 'category/products',
        component: PageShopComponent,
        resolve: {
            productsList: ProductsListResolver,
        },
        data: {
            layout: 'grid',
            gridLayout: 'grid-4-sidebar',
            sidebarPosition: 'start',
        },
    },
    {
        path: 'category/:categorySlug',
        component: PageCategoryComponent,
        data: {
            layout: 'columns-4-sidebar',
        },
        resolve: {
            category: CategoryResolver,
        },
    },
    {
        path: 'listing-type/:categorySlug',
        component: PageShopComponent,
        resolve: {
            category: CategoryResolver,
            productsList: ProductsListResolver,
        },
        data: {
            layout: 'grid',
            gridLayout: 'grid-4-sidebar',
            sidebarPosition: 'start',
        },
    },
    {
        path: 'shop/products/:productSlug',
        component: PageProductComponent,
        // resolve: {
        //     product: ProductResolver,
        // },
        data: {
            layout: 'full',
            sidebarPosition: 'start',
        },
    },


    ...[
        'columns-3-sidebar',
        'columns-4-sidebar',
        'columns-5-sidebar',
        'columns-4-full',
        'columns-5-full',
        'columns-6-full',
        'columns-7-full',
    ].map(layout => ({
        path: `category-${layout}`,
        component: PageCategoryComponent,
        data: {
            layout,
        },
        resolve: {
            children: RootCategoriesResolver,
        },
    })),
    {
        path: 'category-right-sidebar',
        component: PageCategoryComponent,
        data: {
            layout: 'columns-3-sidebar',
            sidebarPosition: 'end',
        },
        resolve: {
            children: RootCategoriesResolver,
        },
    },
    // shop
    ...[
        'grid-3-sidebar',
        'grid-4-sidebar',
        'grid-4-full',
        'grid-5-full',
        'grid-6-full',
    ].map(gridLayout => ({
        path: `shop-${gridLayout}`,
        component: PageShopComponent,
        resolve: {
            category: CategoryResolver,
            productsList: ProductsListResolver,
        },
        data: {
            layout: 'grid',
            gridLayout,
            sidebarPosition: 'start',
            categorySlug: 'headlights-lighting',
        },
    })),
    {
        path: `shop-list`,
        component: PageShopComponent,
        resolve: {
            category: CategoryResolver,
            productsList: ProductsListResolver,
        },
        data: {
            layout: 'list',
            gridLayout: 'grid-4-sidebar',
            sidebarPosition: 'start',
            categorySlug: 'headlights-lighting',
        },
    },
    {
        path: `shop-table`,
        component: PageShopComponent,
        resolve: {
            category: CategoryResolver,
            productsList: ProductsListResolver,
        },
        data: {
            layout: 'table',
            gridLayout: 'grid-4-sidebar',
            sidebarPosition: 'start',
            categorySlug: 'headlights-lighting',
        },
    },
    {
        path: `shop-right-sidebar`,
        component: PageShopComponent,
        resolve: {
            category: CategoryResolver,
            productsList: ProductsListResolver,
        },
        data: {
            layout: 'grid',
            gridLayout: 'grid-4-sidebar',
            sidebarPosition: 'end',
            categorySlug: 'headlights-lighting',
        },
    },
    // product
    {
        path: 'product-full',
        component: PageProductComponent,
        resolve: {
            product: ProductResolver,
        },
        data: {
            layout: 'full',
            sidebarPosition: 'start',
            productSlug: 'brandix-brake-kit-bdx-750z370-s',
        },
    },
    {
        path: 'product-sidebar',
        component: PageProductComponent,
        resolve: {
            product: ProductResolver,
        },
        data: {
            layout: 'sidebar',
            sidebarPosition: 'start',
            productSlug: 'brandix-brake-kit-bdx-750z370-s',
        },
    },
];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [
        CategoryResolver,
        ProductResolver,
        ProductsListResolver,
        RootCategoriesResolver,
    ],
})
export class ShopRoutingModule { }
